import React, { createContext, useContext, useEffect, useState } from "react";

const HeaderSlotContext = createContext({
  slot: null,
  setSlot: () => {},
  titleSlot: null,
  setTitleSlot: () => {},
});

export const HeaderSlotProvider = ({ children }) => {
  const [slot, setSlot] = useState(null);
  const [titleSlot, setTitleSlot] = useState(null);
  return (
    <HeaderSlotContext.Provider value={{ slot, setSlot, titleSlot, setTitleSlot }}>
      {children}
    </HeaderSlotContext.Provider>
  );
};

export const useHeaderSlot = () => useContext(HeaderSlotContext);

// Pages call useHeaderSlotContent(node, [deps]) to render `node` on the far
// right of the header. Pass null/undefined to clear.
export const useHeaderSlotContent = (node, deps = []) => {
  const { setSlot } = useHeaderSlot();
  useEffect(() => {
    setSlot(node);
    return () => setSlot(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

// Pages call useHeaderTitleSlotContent(node, [deps]) to render `node`
// immediately next to the page title (e.g. a status badge).
export const useHeaderTitleSlotContent = (node, deps = []) => {
  const { setTitleSlot } = useHeaderSlot();
  useEffect(() => {
    setTitleSlot(node);
    return () => setTitleSlot(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
